import Vue from 'vue';
import VueRouter, {RouteConfig} from 'vue-router';
import {sync} from 'vuex-router-sync';
import store from './store';
import {routes as routePaths} from './static/routes';
import security from './components/auth';

import {FirmwareUpdates, Home, Invitation, Login, NotFound, Profile} from './views';
import {getKeycloak} from "@/components/auth/keycloak";

Vue.use(VueRouter);

const routes: RouteConfig[] = [
  {
    path: routePaths.LOGIN,
    name: 'Login',
    component: Login,
    meta: {requiresAuth: true},
  },
  {
    path: routePaths.HOME,
    name: 'Home',
    component: Home,
    meta: {requiresAuth: true, role: 'has_registered_product'},
  },
  {
    path: routePaths.PROFILE,
    name: 'Profile',
    component: Profile,
    meta: {requiresAuth: true},
  },
  {
    path: routePaths.INVITATION,
    name: 'Invitation',
    component: Invitation,
    meta: {requiresAuth: true},
  },
  {
    path: routePaths.FIRMWARE_UPDATES,
    name: 'FIRMWARE_UPDATES',
    component: FirmwareUpdates,
  },
  {
    path: '*',
    name: 'NotFound',
    component: NotFound,
  },
];

const router = new VueRouter({
  routes,
  mode: 'history',
});

sync(store, router);

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
    const keycloak = getKeycloak();
    if (!keycloak) {
      security.init(to, next);
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router.ts